import styled from 'styled-components'
import Discontinued from '../iconsV2/Discontinued'
import Paused from '../iconsV2/Paused'
import Pill from '../iconsV2/Pill'

type MedicationStatus = 'active' | 'discontinued' | 'paused' | string

type IconSize = 'small' | 'large'

export const getMedicationIcon = (
  status?: MedicationStatus,
  size: IconSize = 'small'
) => {
  const normalizedStatus = status?.toLowerCase()
  const isLarge = size === 'large'

  if (normalizedStatus === 'discontinued') {
    return (
      <DiscontinuedIconContainer $isLarge={isLarge}>
        <Discontinued />
      </DiscontinuedIconContainer>
    )
  }

  if (normalizedStatus === 'paused') {
    return (
      <PausedIconContainer $isLarge={isLarge}>
        <Paused />
      </PausedIconContainer>
    )
  }

  return (
    <PillIconContainer $isLarge={isLarge}>
      <Pill />
    </PillIconContainer>
  )
}

const PillIconContainer = styled.div<{ $isLarge: boolean }>`
  width: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
  height: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
  flex-shrink: 0;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.color.category.clinicalCare};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $isLarge }) => ($isLarge ? '9px' : '5px')};
`

const DiscontinuedIconContainer = styled.div<{ $isLarge: boolean }>`
  width: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
  height: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
  flex-shrink: 0;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.color.neutral.color9};
  display: flex;
  align-items: center;
  justify-content: center;
`

const PausedIconContainer = styled.div<{ $isLarge: boolean }>`
  width: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
  height: ${({ $isLarge }) => ($isLarge ? '32px' : '24px')};
  flex-shrink: 0;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.color.neutral.color11};
  border: 1px solid ${({ theme }) => theme.color.neutral.color7};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $isLarge }) => ($isLarge ? '9px' : '7px')};
`
